import { SharedBlogService } from '../../shared-blog.service';
import { Router } from '@angular/router';
import { AfterContentInit, Component, ContentChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-article-create',
  templateUrl: './article-create.component.html',
  styleUrls: ['./article-create.component.css']
})
export class ArticleCreateComponent implements AfterContentInit{
  hasCustomTemplate:  boolean = false;
  @ContentChild('customTemplate') public customTemplateRef: ElementRef;
  constructor(public sharedBlogService: SharedBlogService) {}


  ngAfterContentInit() {
    this.hasCustomTemplate = !!this.customTemplateRef;
  }
}
